<template>
  <q-skeleton type="text" height="20px" v-if="isLoading" style="max-width: 200px" />
  <div v-else-if="monitors && monitors.shows.length > 0 && monitors.shows[0].monitor.length > 0">
    <div v-for="(monitor, index) in monitors.shows[0].monitor" :key="index">
    <q-linear-progress
      v-if="monitor.total > 0"
      rounded size="15px" :value="monitor.percentage" :color="monitor.type" track-color="grey-10" style="max-width: 200px" class="q-mb-xs">
      <div class="absolute-full flex flex-center">
        <q-badge color="transparent" text-color="text-white" style="font-size: 10px" :label="`${monitor.label} ${monitor.passed}/${monitor.total}`" />
      </div>
    </q-linear-progress>
      <span v-else>-</span>
    </div>
  </div>
  <div v-else>
    {{nb_entries}}
  </div>
</template>

<script>
import {defineComponent, ref} from 'vue'

export default defineComponent({
  name: 'ShowProgress',
  props: {
    event_id: {
      type: Number,
      default: null
    },
    nb_entries: {
      type: Number,
      default: 0
    },
    show_id: {
      type: String,
      default: null
    },
  },
  data () {
    return {
      isLoading: true,
      monitors: ref({})
    }
  },
  computed: {

  },
  mounted: async function () {
      this.monitors = await this.$store.dispatch("show/getMonitor", {event_id: this.event_id, show_id: this.show_id})
    this.isLoading = false
  },
})
</script>
